import React, { Fragment, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Low(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [Low, setLow] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (Low !== data.Low) {
        setLow(data.Low);
      }
    }
  };

  return (
    <Fragment>
      <div className="bid">Low</div>
      <div className="bidprice">{Low}</div>
    </Fragment>
  );
}
